import React from 'react'
import './Home.css'
import Header from '../Components/Header'
import Footer2 from '../Components/Footer2'
import ParallaxSection from './ParallaxSection'
import { Link } from 'react-router-dom'

export default function Pricing() {
  return ( 
    <>
    <Header/>
    <main class="page_content">
        {/* <!-- Page Banner Section - Start
        ================================================== --> */}
        <section
          class="page_banner_section text-center"
          style={{backgroundImage: `url(${'assets/images/shapes/bg_pattern_4.svg'})`}}
        >
          <div class="container">
            <h1 class="page_title mb-0 text-white">Pricing Plan</h1>
            <p className="text-white mt-2 myPara">Netsole offers flexible pricing plans tailored to suit businesses of all sizes, from startups to enterprises. Each plan includes priority support, and scalable options to match your growth.
            </p>
          </div>
        </section>
        {/* <!-- Page Banner Section - End
        ================================================== --> */}


        {/* <!-- Pricing Section - Start
        ================================================== --> */}
               <section class="pricing_section section_space  bg-light">
          <div className="container margincontainer">
            <h1 class="heading_text text-center mb-5"> Our Pricing Packages</h1>
            <div class="row justify-content-center">
              <div class="col-lg-4">
                              <div class="pricing_block text-center">
                                <div class="table_head flex-column">
                                  <div class="pricing_block_title">
                                    <h3 class="pricing_package_title">Starter Plan</h3>
                                    <p class="pricing_package_description mb-0">
                                    Perfect for individuals and startups looking to establish a strong online presence.
                                    </p>
                                  </div>
                                  <div class="pricing_price_value bg-primary-subtle text-primary">
                                    <span class="pricing_annually">
                                      <del>€200</del> <mark>€99</mark>
                                      <sub>
                                        You'll Save <u>€100</u>
                                      </sub>
                                    </span>
                                  </div>
                                </div>
                                <ul class="icon_list unordered_list_block d-inline-flex">
                                  <li>
                                    <span class="icon_list_icon">
                                      <i class="fa-regular fa-circle-check"></i>
                                    </span>
                                    <span class="icon_list_text">Beautifully designed static website (up to 4 pages)</span>
                                  </li>
                                  <li>
                                    <span class="icon_list_icon">
                                      <i class="fa-regular fa-circle-check"></i>
                                    </span>
                                    <span class="icon_list_text">Fully mobile-responsive and optimized for speed</span>
                                  </li>
                                  <li>
                                    <span class="icon_list_icon">
                                      <i class="fa-regular fa-circle-check"></i>
                                    </span>
                                    <span class="icon_list_text">Clean, modern layout tailored to your brand</span>
                                  </li>
                                  <li>
                                     <span class="icon_list_icon">
                                      <i class="fa-regular fa-circle-check"></i>
                                    </span>
                                   <span class="icon_list_text">
                                    SEO-ready structure for better Google visibility
                                    </span>
                                  </li>
                                  <li>
                                    <span class="icon_list_icon">
                                      <i class="fa-regular fa-circle-check"></i>
                                    </span>
                                    <span class="icon_list_text">Contact form setup included</span>
                                  </li>
                                  <li class="delete">
                                    <span class="icon_list_icon">
                                      <i class="fa-regular fa-circle-check"></i>
                                    </span>
                                    <span class="icon_list_text">
                                    Delivered within 3 days
                                    </span>
                                  </li>
                                  {/* <li class="delete">
                                    <span class="icon_list_icon">
                                      <i class="fa-regular fa-circle-check"></i>
                                    </span>
                                    <span class="icon_list_text"> Cloud Services. </span>
                                  </li> */}
                                </ul>
                                <p class="pricing_package_description mb-5" style={{color:"black",fontSize:"18px"}}>
                                  Great For: Personal websites, resumes, or landing pages
                                    </p>
                                <Link to={"/contact"}>
                                <a class="btn btn-light">
                                  <span class="btn_label" data-text="Start Now">
                                    Start Now
                                  </span>
                                  <span class="btn_icon">
                                    <i class="fa-solid fa-arrow-up-right"></i>
                                  </span>
                                </a>
                                </Link>
                              </div>
                            </div>
                         <div class="col-lg-4">
                             <div class="pricing_block text-center">
                               <div class="table_head flex-column">
                                 <div class="pricing_block_title">
                                   <h3 class="pricing_package_title">Professional Plan</h3>
                                   <p class="pricing_package_description mb-0">
                                   Step up your game with a dynamic, easy-to-manage website.
                                   </p>
                                 </div>
                                 <div class="pricing_price_value bg-primary-subtle text-primary">
                                   <span class="pricing_annually">
                                     <del>€400</del> <mark>€249</mark>
                                     <sub>
                                       You'll Save <u>€150</u>
                                     </sub>
                                   </span>
                                 </div>
                               </div>
                               <ul class="icon_list unordered_list_block d-inline-flex">
                               <li>
                                          <span class="icon_list_icon">
                                       <i class="fa-regular fa-circle-check"></i>
                                   </span>
                                  <span class="icon_list_text">
                                Beautiful Mobile-Responsive website (up to 7 pages)
                                         </span>
                                      </li>
                                 <li>
                                   <span class="icon_list_icon">
                                     <i class="fa-regular fa-circle-check"></i>
                                   </span>
                                   <span class="icon_list_text">Custom design with tailored branding</span>
                                 </li>
                                 <li>
                                   <span class="icon_list_icon">
                                     <i class="fa-regular fa-circle-check"></i>
                                   </span>
                                   <span class="icon_list_text">SEO-ready structure for better Google visibility</span>
                                 </li>
                                 <li>
                                   <span class="icon_list_icon">
                                     <i class="fa-regular fa-circle-check"></i>
                                   </span>
                                   <span class="icon_list_text">Blog or portfolio feature included</span>
                                 </li>

                                 <li>
                                   <span class="icon_list_icon">
                                     <i class="fa-regular fa-circle-check"></i>
                                   </span>
                                       <span class="icon_list_text">
                                         Clean, modern layout tailored to your brand
                                      </span>
                                      </li>
                                
                                 <li class="delete">
                                   <span class="icon_list_icon">
                                     <i class="fa-regular fa-circle-check"></i>
                                   </span>
                                   <span class="icon_list_text">
                                   Social media integration
                                   </span>
                                 </li>
                                 <li class="delete">
                                   <span class="icon_list_icon">
                                     <i class="fa-regular fa-circle-check"></i>
                                   </span>
                                   <span class="icon_list_text">Delivered within 5 days</span>
                                 </li>
                               </ul>
                               <p class="pricing_package_description mb-4" style={{color:"black",fontSize:"18px"}}>
                               Great For: Small businesses, bloggers, creatives, service providers
                                   </p>
                               <Link to={"/contact"}>
                               <a class="btn btn-light">
                                 <span class="btn_label" data-text="Start Now">
                                   Start Now
                                 </span>
                                 <span class="btn_icon">
                                   <i class="fa-solid fa-arrow-up-right"></i>
                                 </span>
                               </a>
                               </Link>
                             </div>
                           </div>
              <div class="col-lg-4">
                            <div class="pricing_block text-center">
                              <div class="table_head flex-column">
                                <div class="pricing_block_title">
                                  <h3 class="pricing_package_title">Premium Plan</h3>
                                  <p class="pricing_package_description mb-0">
                                  For those who need advanced functionality and full control.
                                  </p>
                                </div>
                                <div class="pricing_price_value bg-primary-subtle text-primary">
                                  <span class="pricing_annually">
                                    <del>€700</del> <mark>€499</mark>
                                    <sub>
                                      You'll Save <u>€200</u>
                                    </sub>
                                  </span>
                                </div>
                              </div>
                              <ul class="icon_list unordered_list_block d-inline-flex">
                                <li>
                                  <span class="icon_list_icon">
                                    <i class="fa-regular fa-circle-check"></i>
                                  </span>
                                  <span class="icon_list_text"> Fully-Custom Dynamic website Development</span>
                                </li>
                                <li>
                                  <span class="icon_list_icon">
                                    <i class="fa-regular fa-circle-check"></i>
                                  </span>
                                  <span class="icon_list_text">Custom frontend + backend development</span>
                                </li>
                                <li>
                                  <span class="icon_list_icon">
                                    <i class="fa-regular fa-circle-check"></i>
                                  </span>
                                  <span class="icon_list_text">User login systems, role-based access, and admin panels</span>
                                </li>
                                <li>
                                  <span class="icon_list_icon">
                                    <i class="fa-regular fa-circle-check"></i>
                                  </span>
                                  <span class="icon_list_text">API integrations and dynamic data handling</span>
                                </li>
                                <li class="delete">
                                  <span class="icon_list_icon">
                                    <i class="fa-regular fa-circle-check"></i>
                                  </span>
                                  <span class="icon_list_text">
                                  Performance-optimized and scalable architecture
                                  </span>
                                </li>
                                <li class="delete">
                                  <span class="icon_list_icon">
                                    <i class="fa-regular fa-circle-check"></i>
                                  </span>
                                  <span class="icon_list_text">Delivered within 7–10 days</span>
                                </li>
                              </ul>
                              <p class="pricing_package_description mb-4" style={{color:"black",fontSize:"18px"}}>
                              Great for: Internal tools, dashboards, simple portals (not full SaaS)
                                  </p>
                              <Link to={"/contact"}>
                              <a class="btn btn-light">
                                <span class="btn_label" data-text="Start Now">
                                  Start Now
                                </span>
                                <span class="btn_icon">
                                  <i class="fa-solid fa-arrow-up-right"></i>
                                </span>
                              </a>
                              </Link>
                            </div>
                          </div>
            </div>
            <div class="row justify-content-between">
               <div class="col-lg-4">
                              <div class="pricing_block text-center">
                                <div class="table_head flex-column">
                                  <div class="pricing_block_title">
                                    <h3 class="pricing_package_title">Elite Plan – <br /> Starting From</h3> 
                                    <p class="pricing_package_description mb-0">
                                    Full-scale, custom web apps built for performance, scalability, and growth.
                                    </p>
                                  </div>
                                  <div class="pricing_price_value bg-primary-subtle text-primary">
                                    <span class="pricing_annually">
                                      <del>€900</del> <mark>€699</mark>
                                      <sub>
                                        You'll Save <u>€200</u>
                                      </sub>
                                    </span>
                                  </div>
                                </div>
                                <ul class="icon_list unordered_list_block d-inline-flex">
                                  <li>
                                    <span class="icon_list_icon">
                                      <i class="fa-regular fa-circle-check"></i>
                                    </span>
                                    <span class="icon_list_text"> Full-featured Web application advanced
                                    frameworks
                                    </span>
                                  </li>
                                  <li>
                                    <span class="icon_list_icon">
                                      <i class="fa-regular fa-circle-check"></i>
                                    </span>
                                    <span class="icon_list_text">Complex dashboards, analytics, or custom features
                                    </span>
                                  </li>
                                  <li>
                                    <span class="icon_list_icon">
                                      <i class="fa-regular fa-circle-check"></i>
                                    </span>
                                    <span class="icon_list_text">Secure authentication, role management, and APIs
                                    </span>
                                  </li>
                                  <li>
                                    <span class="icon_list_icon">
                                      <i class="fa-regular fa-circle-check"></i>
                                    </span>
                                    <span class="icon_list_text">Real-time features (chat, notifications, etc.)  
                                    </span>
                                  </li>
                                  <li class="delete">
                                    <span class="icon_list_icon">
                                      <i class="fa-regular fa-circle-check"></i>
                                    </span>
                                    <span class="icon_list_text">
                                    Built for scalability and long-term growth
                                    </span>
                                  </li>
                                  <li class="delete">
                                    <span class="icon_list_icon">
                                      <i class="fa-regular fa-circle-check"></i>
                                    </span>
                                    <span class="icon_list_text">Timeline & pricing based on project scope
                                    </span>
                                  </li>
                                </ul>
                                <p class="pricing_package_description mb-3" style={{color:"black",fontSize:"18px"}}>
                                Great for: SaaS applications, enterprise tools, large-scale Web platforms
                                    </p>
                                <Link to={"/contact"}>
                                <a class="btn btn-light">
                                  <span class="btn_label" data-text="Start Now">
                                    Start Now
                                  </span>
                                  <span class="btn_icon">
                                    <i class="fa-solid fa-arrow-up-right"></i>
                                  </span>
                                </a>
                                </Link>
                              </div>
                            </div>
               {/* <div class="col-lg-6">
                <div class="business_consulting_hero_image">
                  <img
                    class="hero_image"
                    src="assets/images/hero/business_consulting_hero_image_1.webp"
                    alt="Business Consulting"
                  />

                  <div
                    class="funfact_block capsule_layout wow fadeInUp"
                    data-wow-delay=".1s"
                  >
                    <div class="funfact_content">
                      <div class="counter_value">
                        <span class="odometer" data-count="22">0</span>
                        <span>M+</span>
                      </div>
                      <h3 class="funfact_title mb-0">Happy Customer</h3>
                    </div>
                    <div class="funfact_icon">
                      <img
                        src="assets/images/icons/icon_user_3.svg"
                        alt="Techco - SVG Icon User"
                      />
                    </div>
                  </div>
                  <div
                    class="funfact_block capsule_layout wow fadeInUp"
                    data-wow-delay=".2s"
                  >
                    <div class="funfact_icon">
                      <img
                        src="assets/images/icons/icon_wallet.svg"
                        alt="Techco - SVG Icon Wallet"
                      />
                    </div>
                    <div class="funfact_content">
                      <h3 class="funfact_title mb-0">Company Value</h3>
                      <div class="counter_value">
                        <span>$</span>
                        <span class="odometer" data-count="500000">0</span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="funfact_block capsule_layout wow fadeInUp"
                    data-wow-delay=".3s"
                  >
                    <div class="funfact_content pt-2 pb-1">
                      <h3 class="funfact_title mb-0 text-center">
                        Success Rate
                      </h3>
                      <div class="counter_value justify-content-center">
                        <span class="odometer" data-count="98">0</span>
                        <span>%</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </section>

        {/* <!-- Pricing Section - End
        ================================================== --> */}

         {/* <!-- Policy Section - Start
        ================================================== --> */}
        <section class="policy_section section_space">
          <div class="container">
            <div class="heading_block">
              <div class="row justify-content-lg-between">
                <div class="col-lg-6">
                  <h2 class="heading_text mb-0">
                    Celebrating Features Discover What Sets Us
                  </h2>
                </div>
                <div class="col-lg-5">
                  <p class="heading_description mb-0">
                    We take pride in celebrating the features that set us apart
                    and make us a leader in the IT solutions. What truly
                    distinguishes us is our unwavering commitment to innovation,
                    excellence, and client satisfaction.
                  </p>
                </div>
              </div>
            </div>
            <div class="row pricing_policy_wrap">
              <div class="col-lg-4">
                <div class="iconbox_block">
                  <div class="iconbox_icon">
                    <img
                      src="assets/images/icons/icon_doc_1.png"
                      alt="Doc SVG Icon"
                    />
                  </div>
                  <div class="iconbox_content">
                    <h3 class="iconbox_title">Rich Documentation</h3>
                    <p class="mb-0">
                      Rich Documentation" refers to comprehensive and detailed
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="iconbox_block">
                  <div class="iconbox_icon">
                    <img
                      src="assets/images/icons/icon_analysis_1.png"
                      alt="Analysis SVG Icon"
                    />
                  </div>
                  <div class="iconbox_content">
                    <h3 class="iconbox_title">Fastest Delivery</h3>
                    <p class="mb-0">
                    We deliver your project quickly and efficiently — always within the committed timeline.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="iconbox_block">
                  <div class="iconbox_icon">
                    <img
                      src="assets/images/icons/icon_headphone_02.png" 
                      alt="Headphone SVG Icon"
                    />
                  </div>
                  <div class="iconbox_content">
                    <h3 class="iconbox_title">Free 1 Month Support</h3>
                    <p class="mb-0">
                     We Provide 1 Month Free Support for Our Clients on Every Project
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- Policy Section - End
        ================================================== --> */}

        {/* <!-- Client Logo Section - Start
        ================================================== --> */}
      
        {/* <!-- Client Logo Section - End
        ================================================== --> */}

       <ParallaxSection/>
        {/* <!-- Call To Action Section - End
        ================================================== --> */}
        <a className="hotline_block"
          href="https://wa.me/353862359495" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{position:'fixed',
            bottom:'50px',
            right:'20px',
            zIndex:'1000'
          }}
          >
          <span className="hotline_icon">
          <box-icon name='whatsapp' type='logo' animation='tada' color='white' size='lg' ></box-icon>
          </span>
        </a>
      </main>
    <Footer2/>
    </>
  )
}
